import type { IsSupportedEnvResult } from './isSupportedEnv.types';

export async function isSupportedEnv(): Promise<IsSupportedEnvResult> {
  const opfsSupported = await checkOPFS();
  return opfsSupported;
}

async function checkOPFS(): Promise<IsSupportedEnvResult> {
  return new Promise(resolve => {
    const w = new Worker(URL.createObjectURL(new Blob([workerCode], { type: 'text/javascript' })));

    w.onmessage = e => {
      resolve({
        isSupported: e.data.ok,
        reason: e.data.error,
      });
    };
    w.postMessage('go');
  });
}

const workerCode = `
self.onmessage = async () => {
  try {
    const root = await navigator.storage.getDirectory();
    const fileHandle = await root.getFileHandle('test.txt', { create: true });

    const accessHandle = await fileHandle.createSyncAccessHandle();

    const encoder = new TextEncoder();
    const data = encoder.encode('hello safari opfs');

    accessHandle.write(data, { at: 0 });
    accessHandle.flush();
    accessHandle.close();

    await root.removeEntry('test.txt');

    self.postMessage({ ok: true });
  } catch (e) {
    self.postMessage({ ok: false, error: e.message });
  }
};
`;
